/**
 * Quantos itens o dia tem, na célula do calendário.
 *
 * Em 360px cada célula da grade de 7 colunas fica com ~40px. "2 consultas" não cabe: o texto
 * vazava pra célula vizinha e as palavras se sobrepunham. Abaixo de `sm` fica só o número — dentro
 * de um calendário, com o dia logo acima, o número já se explica. A palavra volta onde há largura.
 */
export function ContagemDoDia({
  total,
  singular,
  plural,
}: {
  total: number;
  singular: string;
  plural: string;
}) {
  if (total === 0) return null;
  return (
    <>
      <span
        aria-label={`${total} ${total === 1 ? singular : plural}`}
        className="text-xs font-semibold leading-tight text-brand-600 sm:hidden dark:text-primary"
      >
        {total}
      </span>
      <span className="hidden text-xs font-semibold leading-tight text-brand-600 sm:inline dark:text-primary">
        {total} {total === 1 ? singular : plural}
      </span>
    </>
  );
}
